/** Shared URL slug helper for every geo based landing page (state, county, city). */
export const slugify = (value: string): string =>
  (value ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
